/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";

import {
  ENABLED_STEPS,
  ENABLED_STEPS_COMPONENTS,
  ENABLED_STEP_DESCRIPTIONS,
  DISABLED_STEPS,
  DISABLED_STEPS_COMPONENTS,
  DISABLED_STEP_DESCRIPTIONS,
} from "./constants";

export default function TwoFASwitch({ status, setStatus }) {
  const [data, setData] = useState({
    google2fa_qrcode: "",
    google2fa_code: "",
    one_time_password: "",
  });
  const [openModal, setOpenModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  let STEPS = status ? DISABLED_STEPS : ENABLED_STEPS;
  let STEPS_COMPONENTS = status
    ? DISABLED_STEPS_COMPONENTS
    : ENABLED_STEPS_COMPONENTS;
  let STEP_DESCRIPTIONS = status
    ? DISABLED_STEP_DESCRIPTIONS
    : ENABLED_STEP_DESCRIPTIONS;
  let ActiveComponent = STEPS_COMPONENTS[currentStep];

  useEffect(() => {
    if (!openModal || status) return;
    setLoading(true);
    axios
      .get("/2fa/get-data")
      .then(({ data }) => {
        setData(data.data);
        setLoading(false);
      })
      .catch(({ response }) => {
        console.log(response.data.message);
        setLoading(false);
      });
  }, [openModal, status]);

  const handleEsc = (e) => {
    if (e.keyCode === 27) {
      setOpenModal(false);
    }
  };

  useEffect(() => {
    if (openModal) {
      document.body.classList.add("modal-open");
      document.addEventListener("keydown", handleEsc); 
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [openModal]);

  const handleClose = () => setOpenModal(false);
  const handleOpen = () => setOpenModal(true);
  const handleStep = (step) => () => setCurrentStep(step);
  const handleNext = () =>
    !loading && currentStep + 1 < STEPS.length && setCurrentStep(currentStep + 1);
  const handleBack = () =>
    currentStep - 1 >= 0 && setCurrentStep(currentStep - 1);
  const handleSubmit = () => {
    if (!data.one_time_password || data.one_time_password.length < 6)
      return toast.error("Please enter a valid one time password");
    setSubmitting(true);

    if (status) {
      axios
        .post("2fa/disable", {
          one_time_password: data.one_time_password,
        })
        .then(({ data }) => {
          toast.success(data.message);
        })
        .then(() => {
          setStatus(false);
          setOpenModal(false);
          setSubmitting(false);
          setCurrentStep(0);
          setData({
            ...data,
            one_time_password: "",
          });
        })
        .catch(({ response }) => {
          toast.error(response.data.message);
          setSubmitting(false);
        });
    } else {
      axios
        .post("/2fa/enable", {
          one_time_password: data.one_time_password,
          google2fa_secret: data.google2fa_code,
        })
        .then(({ data }) => {
          setOpenModal(false);
          setSubmitting(false);
          setCurrentStep(0);
          setData({
            google2fa_qrcode: "",
            google2fa_code: "",
            one_time_password: "",
          });
        })
        .then(() => setStatus(true))
        .catch(({ response }) => {
          toast.error(response.data.message);
          setSubmitting(false);
        });
    }
  };

  return (
    <>
      <div className="form-group row">
        <label className="col-xl-3"></label>
        <div className="col-lg-9 col-xl-9">
          <button
            type="button"
            className="btn btn-primary-custom"
            id="2fa_btn_open"
            onClick={handleOpen}
          >
            Setup Google Authentication
          </button>
          <span className="form-text text-muted mb-2 mt-5">
            After you log in, you will be asked for additional information to
            confirm your identity and protect your account from being
            compromised.
          </span>
          {status ? (
            <span className="label label-inline label-success">Activated</span>
          ) : (
            <span className="label label-inline label-danger">Deactivated</span>
          )}
        </div>
      </div>

      {openModal && (
        <div
          className="position-fixed top-0 right-0 left-0 bottom-0 z-50"
          onClick={() => console.log("clicked")}
        />
      )}

      <div
        className={`modal fade${openModal ? " show d-block" : ""}`}
        id="TwoFA"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{
          background: openModal ? "rgb(0 0 0 / 50%)" : "",
          transition: "all 0.3s",
        }}
      >
        <div
          className="modal-dialog modal-dialog-centered qr-code-modal wizared-2fa add-address-modal modal-lg"
          role="document"
        >
          <div className="modal-content tx-14">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Setup Google Authentication
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                style={{
                  background: "transparent",
                  border: "none",
                  padding: 0,
                  fontSize: "2rem",
                  width: "36px",
                }}
                onClick={handleClose}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="tx-13">
                <div id="2faSteps" className="wizard">
                  <div className="steps clearfix">
                    <ul role="tablist">
                      {STEPS.map((label, index) => (
                        <li
                          key={label}
                          role="tab"
                          className={`first ${
                            currentStep > index ? "done" : ""
                          } ${currentStep === index ? "current" : ""}`}
                          aria-disabled="false"
                          aria-selected="true"
                        >
                          <a id="2faSteps-t-0" aria-controls="2faSteps-p-0">
                            <span className="current-info audible">
                              current step:{" "}
                            </span>
                            <span
                              className="number"
                              onClick={handleStep(index)}
                            >
                              {index + 1}
                            </span>{" "}
                            <span className="title">{label}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="content clearfix">
                    <h3>{STEPS[currentStep]}</h3>
                    <section>
                      <h3 className="title current">{STEPS[currentStep]}</h3>
                      <p className="mb-3 max-w-400px opacity-70">
                        {STEP_DESCRIPTIONS[currentStep]}
                      </p>
                      <ActiveComponent data={data} setData={setData} />
                    </section>
                  </div>
                  <div className="actions clearfix">
                    <ul role="menu" aria-label="Pagination">
                      {currentStep === 0 ? (
                        <li onClick={handleClose}>
                          <a role="menuitem" className="cursor-pointer">
                            Cancel
                          </a>
                        </li>
                      ) : (
                        <li onClick={handleBack}>
                          <a role="menuitem" className="cursor-pointer">
                            Previous
                          </a>
                        </li>
                      )}

                      {currentStep + 1 < STEPS.length ? (
                        <li onClick={handleNext}>
                          <a role="menuitem" className="cursor-pointer">
                            Next
                          </a>
                        </li>
                      ) : (
                        <li onClick={!submitting && handleSubmit}>
                          <a className="cursor-pointer" role="menuitem">
                            Submit{submitting ? "ing..." : ""}
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
